<template>
    <div class="home mchp-button-wrapper">
      <div
        class=""
      >
        <div class="row">
          <div class="col-md-12">
            <div class="divHeader">
                <div>
                    Reliability Report
                </div>
              <!-- <div>
             {{ reliabilityData.quarter}}
              </div> -->
              <!-- <div class="publishFontSize">           
              Publish Date: {{ reliabilityData.publishDate}}
              </div> -->
            </div>
            <div class="col-md-12">
            <my-report-list></my-report-list>
            </div>
              </div>
         
        </div>
      </div>
    </div>
</template>

<script>
import MyReportList from "./ReliabalityReport.vue";
import GetReliabilityData from "../../api/realibilityReport"

export default{
    name:"MyReports",
    props:{

    },
    title(){
            return this.$route.meta.title;      
    },
    components:{
        MyReportList
    },
    data(){
        return{
            reliabilityData:[],
        }
    },
    mounted(){
        //  this.GetReliabilityReportLabels();
    },
    methods:{
       
        GetReliabilityReportLabels(){
            let vm=this;
            GetReliabilityData.GetReliabilityReportLabels()
            .then(function(res){
               
                vm.reliabilityData=res;
            })
            .catch((err)=>{
                console.log(err);
            })
        }
    }
}
</script>

<style scoped>
.divHeader
{
    height: 55px;
    display: flex;
    background-color: #f1f2f2;
    font-family: 'Open Sans';
    font-size: 15px;
    line-height: 24px;
    padding-inline:calc(2% + 85px);
    color: black;
    font-size: 1.2rem;
    text-align: center;
    align-items: center;
    font-weight: 600;
}
.publishFontSize{
    font-size: 0.9rem;
    padding-top: 5px;
    padding-bottom: 0px;
    padding-left: 15px;
    padding-right: 15px;
}

@media only screen and (max-width:768px) {
    .divHeader{
      padding-inline: 24px !important;
    }
}
</style>
